import as from 'ansis'
import { Command } from 'commander'
import prettyjson from 'prettyjson'

import { bundle } from '@scalar/json-magic/bundle'
import { fetchUrls, readFiles } from '@scalar/json-magic/bundle/plugins/node'
import { validate } from '@scalar/openapi-parser'

import { output } from '@/helpers/std-out'

/**
 * Validate an OpenAPI file against the OpenAPI specifications
 */
export function ValidateCommand() {
  const cmd = new Command('validate')

  cmd.description('Validate an OpenAPI file')
  cmd.argument('[file|url]', 'File or URL to validate')
  cmd.action(async (inputArgument: string) => {
    const startTime = performance.now()

    if (!inputArgument) {
      return output
        .error()
        .title('Invalid argument')
        .message('Please provide a file path')
        .exit('error')
    }

    const document = await bundle(inputArgument, {
      plugins: [readFiles(), fetchUrls()],
      treeShake: false,
      depth: -1,
    })

    const result = await validate(document)

    if (result.valid && result.version) {
      const endTime = performance.now()
      output
        .info()
        .line(
          as.green(
            `Matches the OpenAPI specification${as.white(` (OpenAPI ${as.bold(result.version)})`)}\n`,
          ),
        )
        .line(
          `${as.green('File validated')} ${as.grey(
            `in ${as.white(`${as.bold(`${Math.round(endTime - startTime)}`)} ms`)}\n`,
          )}`,
        )
        .print()
    } else {
      output
        .error()
        .message(prettyjson.render(result.errors))
        .message(
          as.red(
            `File does not match the OpenAPI ${result.version ? `${result.version} ` : ''}specification.`,
          ),
        )
        .message(
          as.red(
            `${as.bold(
              `${result.errors?.length} error${result.errors && result.errors.length > 1 ? 's' : ''}`,
            )} found.`,
          ),
        )
        .exit('error')
    }
  })

  return cmd
}
